import request from '@/router/axios';

/**
 * 获取实验报告列表
 * @param {String} expUid 实验uid
 */
export const getExpExperimentReports = expUid => {
    return request('/api/exp/expexperimentreport/expreport', {
        params: { expUid }
    });
};


export const getExpExperimentQuery = (page, limit, params) => {
    return request('/api/exp/expexperimentreport/query', {
        params: {
            ...params,
            page,
            limit,
        }
    });
};